import script from "./image.vue?vue&type=script&setup=true&lang=js"
export * from "./image.vue?vue&type=script&setup=true&lang=js"

import "./image.vue?vue&type=style&index=0&id=a4273c3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4273c3a"]])

export default __exports__